import React, { memo } from 'react'

import { Link } from 'gatsby'

import Img from '../Img'

const AuthorPageHeader = ({ data, articleCount }) => {
  return (
    <section className="author-header-section">
      <div className="subsection-one">
        <Img
          image={data?.photo?.gatsbyImageData}
          alt={data?.photo?.alt}
          className="author-photo"
        />
        <ul className="socials">
          {data?.socials.map((item) => (
            <li key={item} className="socials-item">
              <Link
                className="social-link"
                to={item?.social_link?.url}
                target={item?.social_link?.target}
                aria-label={item?.social_icon?.alt || 'Social Image'}
              >
                <Img
                  image={item?.social_icon?.gatsbyImageData}
                  alt={item?.social_icon?.alt}
                  className="mobile-thumbnail"
                />
              </Link>
            </li>
          ))}
        </ul>
      </div>
      <div className="subsection-two">
        <h3 className="title">{data.name}</h3>
        <p className="p p-18 position">{data.position}</p>
        <div className="posts-count">
          {articleCount} post{articleCount === 1 ? '' : 's'}
        </div>
        <p className="p p-18">{data.biography.text}</p>
      </div>
    </section>
  )
}

export default memo(AuthorPageHeader)
